import React, { useEffect, useState } from "react";
import "./GroupeCardDemande.scss";
import BtnBlanc from "Components/Boutons/BtnBlanc/btn-blanc";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { fetchGet, fetchPost } from "Services/api";
import neutralUser from "assets/neutralUser.png";

const GroupeCardDemande = (props) => {
  // Requête actuellement affichée
  const [currentRequest, setCurrentRequest] = useState(undefined);

  // assigne la requête actuelle à la variable currentRequest depuis la BDD
  useEffect(async () => {
    if (props.requestId)
      setCurrentRequest(await fetchGet("/group_members/" + props.requestId));
  }, [props.requestId]);

  // Messages par défaut lors de l'acceptation/refus de la demande
  const DEFAULT_ACCEPT_MESSAGE = "La demande a bien été acceptée";
  const DEFAULT_REFUSE_MESSAGE = "La demande a bien été refusée";
  const DEFAULT_ERROR_MESSAGE = "Une erreur est survenue lors de la requête";

  /**
   * Permet d'accepter ou de refuser une demande d'adhésion à un groupe
   * @param {string} type - accept ou refuse
   */
  const handleRequest = async (type) => {
    var data = await fetchPost(
      "/group_members/join/" + props.requestId + "/" + type,
      "{}",
      props.auth.token
    );
    var isError = data instanceof Error;
    props.setRequestHandle({
      display: true,
      status: isError ? "error" : "success",
      data: isError
        ? isError.message || DEFAULT_ERROR_MESSAGE
        : type == "accept"
        ? DEFAULT_ACCEPT_MESSAGE
        : DEFAULT_REFUSE_MESSAGE,
      header: isError ? "Erreur" : "Succès",
    });
  };

  return (
    <>
      {currentRequest && currentRequest.groupMemberStatus.label == "DEMANDE" && (
        <div className="groupe_card_demande_container">
          <div className="groupe_card_demande_container__logo">
            {!props.url || props.image == "image1" ? (
              <img src={neutralUser} alt="Avatar" title="Avatar" />
            ) : (
              <img src={props.url} alt="Avatar" title="Avatar" />
            )}
          </div>
          <div className="groupe_card_demande_container__info">
            <h6 className="title">{props.userName}</h6>
            <h6>Demande à rejoindre le groupe &quot;{props.group}&quot;</h6>
            <div className="groupe_card_demande_container__info__bouton">
              <div className="accepter">
                <BtnBlanc
                  btnTexte="Accepter"
                  action="button"
                  btnAction={() => handleRequest("accept")}
                />
              </div>
              <div className="refuser">
                <BtnBlanc
                  btnTexte="Refuser"
                  action="button"
                  btnAction={() => handleRequest("refuse")}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

GroupeCardDemande.propTypes = {
  userName: PropTypes.string,
  url: PropTypes.string,
  group: PropTypes.string,
  private: PropTypes.bool,
  membres: PropTypes.number,
  image: PropTypes.string,
  requestId: PropTypes.number,
  setRequestHandle: PropTypes.func,
  auth: PropTypes.object,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(GroupeCardDemande);
